import { ColorTokenKey } from '@faire/web-api--source/indigofair/data/ColorTokenKey';
import { IAction } from '@faire/web-api--source/indigofair/data/IAction';
import { IAvatarElement } from '@faire/web-api--source/indigofair/data/IAvatarElement';
import { IButtonElement } from '@faire/web-api--source/indigofair/data/IButtonElement';
import { IImageElement } from '@faire/web-api--source/indigofair/data/IImageElement';
import { IResponsiveImage } from '@faire/web-api--source/indigofair/data/IResponsiveImage';
import { ISDUIAvatar } from '@faire/web-api--source/indigofair/data/ISDUIAvatar';
import { ISDUIButton } from '@faire/web-api--source/indigofair/data/ISDUIButton';
import { ISDUIImage } from '@faire/web-api--source/indigofair/data/ISDUIImage';
import { ISDUIText } from '@faire/web-api--source/indigofair/data/ISDUIText';
import { ITextElement } from '@faire/web-api--source/indigofair/data/ITextElement';

export namespace IHeaderComponent {
  export namespace IHeaderComponentStyle {
    /**
     * Return an instance of IHeaderComponentStyle with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IHeaderComponentStyle>
    ): IHeaderComponentStyle =>
      ({
        ...(partial ?? {}),
      }) as IHeaderComponentStyle;
  }

  /**
   * Deprecated
   */
  export interface IHeaderComponentStyle {
    background_color: keyof typeof ColorTokenKey | undefined;
  }

  /**
   * Return an instance of IHeaderComponent with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IHeaderComponent>
  ): IHeaderComponent =>
    ({
      button_list: [],
      on_click: [],
      button_list_element: [],
      ...(partial ?? {}),
    }) as IHeaderComponent;
}

/**
 * Header
 */
export interface IHeaderComponent {
  /**
   * @deprecated
   */
  tagline: ITextElement | undefined;
  /**
   * @deprecated
   */
  title: ITextElement | undefined;
  /**
   * @deprecated
   */
  sub_title: ITextElement | undefined;
  /**
   * Deprecated. Please use the style at the Component level.
   * TODO(philip.bao): Remove after the usage is not referred by app(August 1).
   * @deprecated
   */
  style: IHeaderComponent.IHeaderComponentStyle | undefined;
  /**
   * @deprecated
   */
  button_list: Array<IButtonElement>;
  /**
   * Used to render a button within the text stack, positioned as a prefix to the subtitle
   * @deprecated
   */
  inline_cta_button: IButtonElement | undefined;
  /**
   * Makes the entire container clickable
   */
  on_click: Array<IAction>;
  responsive_background_image: IResponsiveImage | undefined;
  /**
   * Non-deprecated element fields
   */
  tagline_element: ISDUIText | undefined;
  title_element: ISDUIText | undefined;
  sub_title_element: ISDUIText | undefined;
  button_list_element: Array<ISDUIButton>;
  /**
   * @deprecated
   */
  avatar_element: IAvatarElement | undefined;
  /**
   * @deprecated
   */
  image_element: IImageElement | undefined;
  avatar: ISDUIAvatar | undefined;
  image: ISDUIImage | undefined;
}
